import React, { useEffect } from 'react';

import "./FormConfirm.scss";

export default function FormConfirm() {
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 10);
    }, []);
    return (
        <>
            <div className='banner2 banner-fc'>
                <div className='container-fluid'>
                    <table width="100%" cellPadding="0" cellSpacing="0" border="0">
                        <tbody>
                            <tr><td><h1 className='fw-300 txt-center'>Thank You</h1></td></tr>
                            <tr>
                                <td>
                                    <div className="checkmark mb-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                        </svg>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div data-aos="fade-up" data-aos-once='true'>
                <div className='container-fluid sectin pt-0'>
                    <p className='f-18 txt-white mxw-700 m-auto mb-0 txt-center'>Thanks for reaching out!</p>
                    <p className='f-18 txt-white mxw-700 m-auto txt-center'>Your message just showed up in my inbox. Talk to you soon!</p>
                    <div className='txt-center'><a className="glow-btn" href="#/"><span>Back to Home</span></a></div>
                </div>
            </div>
        </>
    )
}
